export function tickerValuePreFormatter(max: number, value: number): number {
    return value / max;
}
